export const money = (value, currency = "USD") =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export const number = (value) => new Intl.NumberFormat("fr-FR").format(Number(value || 0));

export const percent = (value) => `${Number(value || 0).toFixed(2)}%`;

export const dateOnly = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("fr-FR");
};
